// How long a cached API response stays servable. These are latency budgets, not
// consistency guarantees: everything cached here is also invalidated explicitly
// when the app mutates it, so the TTL only bounds staleness caused by *someone
// else* changing the data.

/**
 * The users roster. Short, because an admin acting on this list expects to see a
 * colleague's ban within about a minute, and because the search box is the whole
 * reason for the cache — a term re-typed inside the same minute is the common case.
 */
export const ADMIN_USERS_CACHE_TTL_MS = 60_000;

/** The activity feed. Append-only, so a stale page only ever lacks recent rows. */
export const ADMIN_ACTIVITY_CACHE_TTL_MS = 60_000;

/**
 * Dashboard statistics. Longer: they aggregate over days, so a minute of drift is
 * invisible, and the query behind them is the most expensive of the three.
 */
export const ADMIN_STATS_CACHE_TTL_MS = 5 * 60_000;

/**
 * Entries kept per cache before the least recently used one is dropped. Typing a
 * search term produces one entry per debounced keystroke, so this is what stops a
 * long session from growing the cache without bound.
 */
export const REQUEST_CACHE_MAX_ENTRIES = 50;
